import { apiClient } from '@/utils/api-client'

const API_INTERNAL_BASE = '/projects'

/**
 * Environment context attribute service.
 */
class EnvironmentContextAttributeService {
    /**
     * List context attributes for an environment.
     *
     * @param {string} projectKey - Project key
     * @param {string} environmentKey - Environment key
     * @returns {Promise<Object>} Attribute list response
     */
    async list(projectKey, environmentKey) {
        return await apiClient
            .get(
                API_INTERNAL_BASE +
                    '/' +
                    projectKey +
                    '/environments/' +
                    environmentKey +
                    '/context-attributes'
            )
            .then((response) => {
                return response.data
            })
    }
}

export default new EnvironmentContextAttributeService()
